<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
      
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <!-- Top Navbar -->
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Order Details</h2>
          <button @click="$router.push('/admin/orders')" class="px-4 py-2 bg-blue-500 rounded-lg hover:bg-blue-600">Back to Orders</button>
        </header>
        
        <!-- Order Details -->
        <main class="p-6 flex-1">
          <div v-if="order" class="bg-gray-800 p-6 rounded-xl shadow-md">
            <h3 class="text-lg font-semibold mb-4">Order #{{ order.id }}</h3>
            <p class="text-gray-300"><strong>Customer:</strong> {{ order.name }}</p>
            <p class="text-gray-300"><strong>Plan:</strong> {{ order.plan }}</p>
            <p class="text-gray-300"><strong>Total Amount:</strong> ${{ order.amount }}</p>
            <p class="text-gray-300"><strong>Date:</strong> {{ formattedDate }}</p>
          </div>
          <div v-else class="text-gray-300">Loading order details...</div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/adminnav.vue';
  import axios from 'axios';
  
  export default {
    name: "OrderDetails",
    components: { Navbar },
    data() {
      return {
        order: null,
      };
    },
    computed: {
      formattedDate() {
        return this.order ? new Date(this.order.created_at).toLocaleDateString("en-US") : "";
      }
    },
    async created() {
      const orderId = this.$route.params.id;
      try {
        const response = await axios.get(`https://api.syniac.com:3000/api/admin/order/orders/${orderId}`, { withCredentials: true });
        console.log(response.data)
        this.order = response.data.order;
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    }
  };
  </script>
  
